import Vue from "vue";
import VueRouter from "vue-router";
import CLCHomePageRebrand from "@/components/CLCHomePageRebrand";
import CLCNewsDetail from "@/components/CLCNewsDetail";
import Preview from "@/components/Preview";

Vue.use(VueRouter);

const routes = [
  {
    path: "/preview",
    component: Preview,
  },
  {
    path: "/",
    component: CLCHomePageRebrand,
  },
  {
    path: "/en/",
    component: CLCHomePageRebrand,
  },
  {
    path: "/es/",
    component: CLCHomePageRebrand,
  },
  {
    path: "/en/news/:id",
    component: CLCNewsDetail,
  },
  {
    path: "/es/news/:id",
    component: CLCNewsDetail,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
